import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  LinearProgress,
} from '@mui/material';
import { OptimizationStrategy } from '../types';

interface OptimizationStrategiesProps {
  strategies: OptimizationStrategy[];
}

const OptimizationStrategies: React.FC<OptimizationStrategiesProps> = ({ strategies }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Optimization Strategies
      </Typography>
      <List>
        {strategies.map((strategy) => (
          <ListItem key={strategy.id}>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {strategy.name}
                  <Chip
                    size="small"
                    label={`${strategy.performance}%`}
                    color={strategy.isActive ? 'success' : 'default'}
                  />
                </Box>
              }
              secondary={
                <Box sx={{ mt: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={strategy.performance}
                    color={strategy.isActive ? 'primary' : 'secondary'}
                  />
                  <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                    {strategy.description}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default OptimizationStrategies; 